var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJ(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.868,
    height: 26.404,
    viewBox: "0 0 12.868 26.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "j",
    transform: "translate(-4.25 -3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M19.234,18.973a3.237,3.237,0,0,1-.474-1.611V7.328a5.078,5.078,0,1,0-10.156,0V17.361a3.143,3.143,0,0,1-.46,1.584,6.449,6.449,0,0,0,1.53,8.314A6.4,6.4,0,0,0,13.7,28.654a6.139,6.139,0,0,0,1.489-.176,6.42,6.42,0,0,0,4.049-9.506ZM12.666,7.328a1.016,1.016,0,1,1,2.031,0V19.514a1.016,1.016,0,0,1-2.031,0Zm1.043,17.264a1.023,1.023,0,0,1-1.016-1.016,1.011,1.011,0,0,1,1-1.016h.014a1.016,1.016,0,1,1,0,2.031Z",
    transform: "translate(-3 1)",
    fill: "#2772af"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ);
export default __webpack_public_path__ + "static/media/j.13b5a6a7d0185f4a96b5b56f92125689.svg";
export { ForwardRef as ReactComponent };